import { useFlags } from 'flagsmith/react';
import { useMemo } from 'react';
import { customUseFlags } from 'src/hooks/customUseFlags';

export function useTranscriptionFlag() {
  const flag = useFlags(['ia_transcription']);
  const ia_transcription = customUseFlags(flag.ia_transcription);

  // Verifica se a flag está habilitada
  const canShowTranscription = useMemo(() => {
    return flag.ia_transcription?.enabled;
  }, [flag.ia_transcription]);

  return {
    canShowTranscription,
    canUseTranscription: ia_transcription,
  };
}
